import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'react-native'
import { useDispatch } from 'react-redux'

import { faIdBadge } from '@fortawesome/pro-light-svg-icons'

import { FaIcon } from '../../../../App/Components'
import { useHistory, useParams } from '../../../../Router'
import { setCurrentCustomerIndex } from '../../../store/Actions'

import {
  LConnector,
  SelectPersonContainer,
  SelectPersonText,
} from '../../../../SelectPerson/style'
import { IMenuActivity } from '../../../../Menu/Store/IMenuActivity'

type Props = {
  isSelectIndividualPerson: boolean
  activity: IMenuActivity
  customerIndex: number
  highlightcolor: string
}

const buttonReset: React.CSSProperties = {
  appearance: 'none',
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  font: 'inherit',
  textAlign: 'left',
  width: '100%',
  color: 'inherit',
}

/**
 * OB-499: Native <button>. Was TouchableOpacity.
 */
export const SelectPersonPerActivity: FunctionComponent<Props> = ({
  isSelectIndividualPerson,
  customerIndex,
  activity,
  highlightcolor,
}) => {
  const { t } = useTranslation()
  const { establishmentId } = useParams<{ establishmentId: string }>()
  const history = useHistory()
  const dispatch = useDispatch()

  if (!isSelectIndividualPerson) {
    return null
  }

  const onSelectPerson = () => {
    dispatch(setCurrentCustomerIndex(customerIndex))
    history.push(
      `/${establishmentId}/select-person/${customerIndex}/${activity.id}`
    )
  }

  return (
    <button type="button" style={buttonReset} onClick={onSelectPerson}>
      <SelectPersonContainer
        data-component="select-person-container"
        highlightcolor={highlightcolor}
      >
        <LConnector highlightcolor={highlightcolor} />
        <FaIcon size="sm" icon={faIdBadge} color={highlightcolor} />
        <Text style={{ color: highlightcolor, marginLeft: 6 }}>
          {activity.personSelected ? (
            activity.personSelected.firstName
          ) : (
            <SelectPersonText highlightcolor={highlightcolor}>
              {t('Select preferred employee')}
            </SelectPersonText>
          )}
        </Text>
      </SelectPersonContainer>
    </button>
  )
}
